import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  CreateSpendingCategoryEstimateInput,
  UpdateSpendingCategoryEstimateInput,
} from '../generated/graphql';
import {
  clientCreateSpendingCategoryEstimate,
  clientUpdateSpendingCategoryEstimate,
  useGraphqlClient,
} from '../graphql';
import { openNotification } from '../UI';
import { spendingCategoryEstimateKeys } from './queryKeys';

export const useCreateSpendingCategoryEstimate = () => {
  const gqlClient = useGraphqlClient();
  const queryClient = useQueryClient();
  const { t: tFirmClient } = useTranslation('firmClient');

  const createSpendingCategoryEstimate = useMutation({
    mutationKey: ['createSpendingCategoryEstimate'],
    mutationFn: (input: CreateSpendingCategoryEstimateInput) =>
      clientCreateSpendingCategoryEstimate(gqlClient, input),
    onError: () => {
      openNotification({
        type: 'error',
        description: tFirmClient('error-unable-to-update-spending'),
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(
        spendingCategoryEstimateKeys.spendingCategoryEstimates(variables.householdID)
      );
    },
  });

  return { createSpendingCategoryEstimate };
};

export const useUpdateSpendingCategoryEstimate = () => {
  const gqlClient = useGraphqlClient();
  const queryClient = useQueryClient();
  const { t: tFirmClient } = useTranslation('firmClient');

  const updateSpendingCategoryEstimate = useMutation({
    mutationKey: ['updateSpendingCategoryEstimate'],
    mutationFn: (input: UpdateSpendingCategoryEstimateInput) =>
      clientUpdateSpendingCategoryEstimate(gqlClient, input),
    onError: () => {
      openNotification({
        type: 'error',
        description: tFirmClient('error-unable-to-update-spending'),
      });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(
        spendingCategoryEstimateKeys.spendingCategoryEstimates(variables.householdID)
      );
    },
  });

  return { updateSpendingCategoryEstimate };
};
